module.exports = __webpack_public_path__ + "static/locations_socialdesk-3d9b814e2b3f2500e58e72ce20a577a9.svg";